export default function contentContainsStream({ streams = [] }, stream = {}) {
    return streams.some(({ id }) => id === stream.id);
}



// WEBPACK FOOTER //
// ./app/lib/auth/contentContainsStream.js